import React, { CSSProperties, ReactNode } from 'react'
import { ExplainBoxWrapper, ExplainBoxText, ExplainBoxValue } from './ExplainBox.styled'

type ExplainBoxProps = {
  text: string
  value: string | ReactNode
  style?: CSSProperties
}

export const ExplainBox = ({ text, value, style }: ExplainBoxProps) => {
  return (
    <ExplainBoxWrapper style={style}>
      <ExplainBoxText>{text}</ExplainBoxText>
      <ExplainBoxValue>{value}</ExplainBoxValue>
    </ExplainBoxWrapper>
  )
}
